import { render, staticRenderFns } from "./editPartner.vue?vue&type=template&id=65ad4e88"
import script from "./editPartner.vue?vue&type=script&lang=js"
export * from "./editPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports